<template class="xc">
  <div>
    <div>
      <div v-if="isDarkMode">
        <v-app dark>
          <frame />
        </v-app>
      </div>
      <div v-else>
        <v-app>
          <frame />
        </v-app>
      </div>
    </div>
  </div>
</template>

<script>
import service from "./service/Service";
import "primeflex/primeflex.css";
import { mapState, mapActions } from "vuex";
import "../primevue/resources/themes/saga-blue/theme.css";
import axios from "axios";
import Vue from "vue";
import(process.env.VUE_APP_CSS);

const frame = () => import("./components/Frame");
export default {
  data() {
    return {
      change: 0,
      isLoading: false,
      service: null,
      gradeService: null,
      presenceService: null,
      subjectService: null,
      pupilService: null,
      lessonTimeService: null,
      presenceStatusService: null,
    };
  },
  created() {
      this.service = new service();
  },
  watch: {
    isDarkMode(newCount, oldCount) {
      let themeElement = document.getElementById("theme-link");
      if (newCount === true) {
        themeElement.setAttribute(
          "href",
          themeElement
            .getAttribute("href")
            .replace(
              "themes/saga-blue/theme.css",
              "themes/luna-amber/theme.css"
            )
        );
      } else {
        themeElement.setAttribute(
          "href",
          themeElement
            .getAttribute("href")
            .replace(
              "themes/md-dark-indigo/theme.css",
              "themes/saga-blue/theme.css"
            )
        );
      }
    },
    user(a, b) {
      if (a !== null) {
        this.fillStore();
      }
    },
  },
  mounted() {
     const startDate = Vue.ls.get('startDateDefaultRequest', 0)
      const endDate = Vue.ls.get('endDateDefaultRequest', 9999999999999)
      if (startDate) axios.defaults.headers.common['startDate'] =  startDate
      if (endDate) axios.defaults.headers.common['endDate'] =  endDate

    axios.defaults.headers.common['authorization'] =
        localStorage.getItem("authorization")
    // setTimeout(() =>{
    // if (this.isDarkMode) {
    //   require('primevue/resources/themes/bootstrap4-dark-blue/theme.css');
    // } else {
    // this.style.remove();

    // require('primevue/resources/themes/saga-blue/theme.css');

    // }
    // },1000)
    // this.$nextTick(() => {
    //
    // })

    if (localStorage.getItem("authorization")) {
      this.service
        .getMe("user")
        .then((data) => {
          this.setUser(data.user);
            console.log("data.permissions", data.permissions)
            this.setPermissions(data.permissions);

            this.service.getMySettings("user-settings").then((settings) => {
            this.setUserSettings(settings);
          });
        })
        .catch((error) => {
          if (error.response.status) {
            this.openNotification(
              "danger",
              `אופס`,
              `לא הצלחנו למצוא את המשתמש במערכת שלנו`
            );
            localStorage.removeItem("authorization");
            this.$router.push("/login").catch(() => {
              this.$router.go(0);
            });
          } else {
            this.openNotification(
              "danger",
              `אופס`,
              `קרתה תקלה בהתחברות למערכת`
            );
          }
        });
      // this.fillStore()
    }
    // setTimeout(() => {
    //   this.isLoading = true
    // }, 0)
  },

  components: {
    frame,
  },
  methods: {
      setStartAndEndDateRequests(){
        if (this.user.role === 'ADMIN')  {
           const startDate = Vue.ls.get('startDateDefaultRequest', 1661723473369);
           const endDate = Vue.ls.get('endDateDefaultRequest', 1661723473369);
            axios.defaults.headers.common['startDate'] = startDate
            axios.defaults.headers.common['endDate'] = endDate
        } else {
            //TODO: gert setting from server
            axios.defaults.headers.common['startDate'] = 1661723473369
            axios.defaults.headers.common['endDate'] = 1690750800000
        }
      },
    async fillStore() {
      this.service.get("teacher").then((data) => {
        this.setTeachers(data);
      });
      this.service.get("pupil").then((data) => {
        this.setPupils(data);
        // setTimeout(() => {
        data.forEach((element) => {
          element.grade = this.getGradeObj(element.grade);
        });
        this.setPupils(data);
      });

      this.service.get("grade").then((data) => {
        this.setGradeOptions(data);
        this.service.get("pupil").then((data) => {
          this.setPupils(data);

          data.forEach((element) => {
            element.grade = this.getGradeObj(element.grade);
          });

          this.setPupils(data);
        });
      });

      this.service.get("subject").then((data) => {
        this.setSubjectLesson(data);
      });
      this.service.get("lesson-time").then((data) => {
        this.setLessonTime(data);
      });
      this.service.get("subject-tracing").then((data) => {
        this.setSubjectTracing(data);
      });
      this.service
        .get("presence-status")
        .then((data) => {
          this.setPresenceStatus(data);

        })
        .catch((error) => {
          this.openNotification(
            "danger",
            `אופס`,
            `קרתה תקלה בטעינת הנתונים במערכת`
          );
        });
    },
    openNotification(
      color,
      title,
      text,
      position = "right-left",
      duration = 3000
    ) {
      this.$vs.notification({
        color,
        position,
        title,
        text,
        duration,
        progress: "auto",
      });
    },
    ...mapActions([
      "setUser",
      "setPermissions",
      "setTeachers",
      "setGradeOptions",
      "setPresenceStatus",
      "setSubjectLesson",
      "setSubjectTracing",
      "setPupils",
      "setLessonTime",
      "setUserSettings",
    ]),
    getGradeObj(gradeId) {
      return this.gradeOptions.find((grade) => grade.id === gradeId);
    },
    getTeacherObj(teacherId) {
      return this.teachers.find((teacher) => teacher.id === teacherId);
    },
  },
  computed: {
    ...mapState([
      "isDarkMode",
      "teachers",
      "user",
      "gradeOptions",
      "isStateReady",
    ]),
  },
};
</script>

<style>
.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month {
    margin-left: 0.5rem;
}

.p-autocomplete-dd .p-autocomplete-dropdown {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 3px !important;
    border-bottom-left-radius: 3px !important;
}

.p-autocomplete-dd .p-autocomplete-input, .p-autocomplete-dd .p-autocomplete-multiple-container {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.p-tooltip-text {
  text-align: center;
}
.p-inputgroup-addon:first-child, .p-inputgroup button:first-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
}
.p-tooltip {
}
/*@import "primevue/resources/themes/saga-blue/theme.css";*/
/** {*/
/*  !*margin: 0;*!*/
/*  !*height: 100%;*!*/
/*  !*overflow-x: hidden;*!*/
/*  !*overflow-y: auto;*!*/
/*  background-color: var(--surface-a);*/
/*  !*font-family: var(--font-family);*!*/
/*  !*font-weight: 400;*!*/
/*  color: var(--text-color);*/
/*}*/
.row-unenabled {
  color: #878787 !important;
}

.row-unenabled .subject-tracking.t-danger {
  filter: opacity(0.4);
}
.row-unenabled .subject-tracking.t-warning {
  filter: opacity(0.4);
}
.row-unenabled .subject-tracking.t-success {
  filter: opacity(0.4);
}
.row-unenabled .subject-tracking.t-help {
  filter: opacity(0.4);
}
.row-unenabled .subject-tracking.t-info {
  filter: opacity(0.4);
}
.row-unenabled .subject-tracking.t-secondary {
  filter: opacity(0.4);
}
.p-dropdown-panel .p-dropdown-header .p-dropdown-filter {
  width: 100% !important;
}
.subject-tracking.t-danger {
  background-color: #ffcdd2;
  color: #c63737;
}
.subject-tracking.t-error {
  background-color: #ffcdd2;
  color: #c63737;
}

.subject-tracking.t-warning {
  background: #feedaf;
  color: #8a5340;
}
.subject-tracking.t-warn {
    background: #feedaf;
    color: #8a5340;
}

.subject-tracking.t-success {
  background: #c8e6c9;
  color: #256029;
}

.subject-tracking.t-help {
  background-color: #eccfff;
  color: #694382;
}

.subject-tracking.t-info {
  background-color: #b3e5fc;
  color: #23547b;
}

.subject-tracking.t-secondary {
  background-color: #acaeaf;
  color: #343131;
}

.subject-tracking {
  border-radius: 2px;
  /*padding: 0.25em 0.5rem;*/
  text-transform: uppercase;
  font-weight: 700;
  /*font-size: 12px;*/
  letter-spacing: 0.3px;
}
.p-timepicker {
  direction: ltr !important;
}
.p-card .p-card-title {
  text-align: center;
}
.p-card .p-card-subtitle {
  text-align: center;
}
.p-input-icon-right > i:last-of-type {
  left: 0.5rem !important;
}

.p-float-label > label {
  right: 0.5rem !important;
}

* {
  /*@import 'primevue/resources/themes/saga-blue/theme.css'*/
}

.xc {
  /*@import 'primevue/resources/themes/saga-blue/theme.css'*/
}

.vs-notification__close {
  left: 2px !important;
  right: 0px !important;
}

a {
  cursor: pointer;
}

.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3250;
  /* margin: 150px; */
}

.app-container {
  text-align: center;
}

.p-calendar {
  color: yellow !important;
}

.p-datepicker table th {
  padding: 0.5rem;
  text-align: center !important;
}

.p-datepicker {
  direction: rtl !important;
}
.p-datepicker .p-datepicker-header .p-datepicker-prev,
.p-datepicker .p-datepicker-header .p-datepicker-next {
  transform: rotateY(180deg);
}
.p-paginator {
  direction: rtl;
}

.p-paginator-icon {
  transform: scaleX(-1);
}

.p-fluid .p-calendar .p-inputtext {
  text-align: center !important;
}

/*td {*/
/*  text-align: right !important;*/
/*}*/

p {
  text-align: right !important;
}

h4 {
  text-align: right !important;
}

.p-tooltip {
  z-index: 1000 !important;
}

th {
  text-align: right !important;
}

/*.p-datatable-header{*/
/*  background:  #fbbf2c !important;*/

/*}*/
.v-toolbar__content {
  background: var(--primary-color);
}

.p-dialog-header {
  /*background: #fbbf2c !important;*/
  background: var(--primary-color) !important;
}

.p-datepicker-trigger .presence-view {
  border-radius: 0px !important;
}

.p-inputgroup-addon:last-child,
.p-inputgroup .calendar-picker-presence button:last-child,
.p-inputgroup input:last-child,
.p-inputgroup > .p-inputwrapper.calendar-hebrew:last-child,
.p-inputgroup > .p-inputwrapper.calendar-hebrew:last-child > .p-inputtext {
  border-radius: 0px !important;
}

.p-inputgroup-addon.plus:first-child,
.p-inputgroup .plus button:first-child,
.p-inputgroup input:first-child,
.p-inputgroup > .p-inputwrapper:first-child,
.p-inputgroup > .p-inputwrapper:first-child > .p-inputtext {
  /*border-top-left-radius: 3px !important;*/
  /*border-bottom-left-radius: 3px !important;*/
  /*border-top-right-radius: 0px;*/
  /*border-bottom-right-radius: 0px;*/
}

.p-inputgroup > .p-component + .p-inputgroup-addon,
.p-inputgroup > .p-inputwrapper > .p-inputtext + .p-inputgroup-addon,
.p-inputgroup > .p-float-label > .p-component + .p-inputgroup-addon {
  border-top-left-radius: 3px !important;
  border-bottom-left-radius: 3px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.card-loading{
    filter: opacity(0.5);
}

.p-inputgroup-addon.minus:first-child,
.p-inputgroup .minus button:first-child,
.p-inputgroup input:first-child,
.p-inputgroup > .p-inputwrapper:first-child,
.p-inputgroup > .p-inputwrapper:first-child > .p-inputtext {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
</style>
